export const useRequestUrl = ({ reqUrl }: { reqUrl: string }) => {
  const requestUrl = `${process.env.REACT_APP_LOCAL_URL}${reqUrl}`
  return requestUrl
}
